div.eventInfoCard {
  display: flex;
  flex-flow: row nowrap;
  background-color: white;
  border: solid 1px #eaeaea;
  border-radius: 0.75rem;
  width: max-content;

  > div.leftIcon {
    height: 120px;
    aspect-ratio: 1 / 1;
    margin: 0.5rem;

    > img {
      border-radius: 0.5rem;
      max-width: 100%;
    }
  }

  > div.rightBlock {
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    padding: 0.75rem;
    max-width: 16rem;
    gap: 10px;
  }

  .liveStreamInfoBlock {
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    padding: 0.75rem;
  }

  .actionBlock {
    display: flex;
    flex-flow: row nowrap;
    gap: 10px;
    padding: 10px 0;
    margin-top: 0.5rem;
    border-top: 1px solid #eaeaea;
    border-bottom: 1px solid #eaeaea;
  }

  .postActionBlock {
    display: flex;
    flex-flow: row nowrap;
    gap: 10px;
    padding-top: 10px;
  }

  .smallText {
    font-size: 12px;
    color: var(--bs-gray-700);
    margin-bottom: 0;
  }

  .basicButton {
    font-size: 0.85rem;
    border-radius: 5px;
    border: 1px solid rgb(217, 217, 217);
    padding: 0.25rem 0.5rem;
    display: flex;
    align-items: center;
    gap: 0.4rem;
    background-color: white;
    margin-top: auto;
    width: fit-content;

    &:hover {
      background-color: var(--bs-gray-100);
    }
  }

  .eventSharing {
    display: flex;
    flex-flow: row nowrap;
    gap: 0.5rem;

    a,
    button {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 2.25rem;
      width: 2.25rem;
      border-radius: 5rem;
      border: solid 2px #707d8f;
      transition: all 0.3s ease-in-out;

      img {
        fill: #707d8f;
        transition: all 0.3s ease-in-out;
        width: 50%;
      }

      svg {
        fill: #707d8f;
        transition: all 0.3s ease-in-out;
      }

      &:hover {
        background-color: #707d8f;

        svg {
          fill: white;
        }
      }
    }
  }

  .hiddenOffScreen {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }
}

.eventVideoModalHeader {
  border-bottom: none;
  padding-bottom: 0;
}
